<div class="entry-page-form" [formGroup]="form">
    <div class="form-group">
        <label class="form-label">Primary Country</label>
        <cm-select
            class="form-control inner-component"
            [options]="allCountries"
            formControlName="countryId"
            [ngClass]="{ 'is-invalid': showError && !form.get('countryId').value }"
            (ngModelChange)="onCountryChange($event)"
        >
        </cm-select>
    </div>
    <div class="form-group">
        <label class="form-label">Primary {{ organizationLabels[OrganizationsLabelType.LOCATION_REGION] }}</label>
        <cm-select
            class="form-control inner-component"
            [cmDisableControl]="!form.get('countryId').value || disabled"
            [options]="regions"
            formControlName="regionId"
            [ngClass]="{ 'is-invalid': showError && form.get('countryId').value && !form.get('regionId').value }"
            (ngModelChange)="onRegionChange([$event])"
        >
        </cm-select>
    </div>
    <div class="form-group">
        <label class="form-label">Primary {{ organizationLabels[OrganizationsLabelType.LOCATION_OFFICE] }}</label>
        <cm-select
            class="form-control inner-component"
            [cmDisableControl]="!form.get('regionId').value || disabled"
            [options]="offices"
            formControlName="officeId"
            [ngClass]="{ 'is-invalid': showError && form.get('regionId').value && !form.get('officeId').value }"
        >
        </cm-select>
    </div>
</div>
